class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.closest("[data-accordion-list]");
    this.content = this.querySelector(".accordion-new__wrapper");
    this.titleWrapper = this.querySelector(".accordion-new__title");
    this.metafield_wrapper = this.querySelector(
      ".metafield-multi_line_text_field"
    );
    if (this.metafield_wrapper) {
      this.parseTable();
    }
    this.setEventListener();
  }
  setEventListener() {
    this.addEventListener("click", this.onToggleAccordion.bind(this));
  }
  onToggleAccordion(e) {
    if (this.classList.contains("open")) {
      this.onClose();
    } else {
      const allItems = this.wrapper.querySelectorAll("accordion-new-web");
      allItems.forEach((item) => item.onClose());
      this.onOpen();
    }
  }
  onOpen() {
    this.classList.add("open");
    this.content.style.transition = `max-height .35s ease-out`;
    this.content.style.maxHeight = this.content.scrollHeight + "px";
    this.scrollIfNeeded.call(this, this.titleWrapper);
  }
  onClose() {
    this.classList.remove("open");
    this.content.style.transition = `max-height .35s ease-out`;
    this.content.style.maxHeight = null;
  }
  parseTable() {
    const table = this.metafield_wrapper.textContent;
    this.querySelector(".accordion-new__table").innerHTML = table;
  }
  scrollToElement(element) {
    const duration = this.time * 1000;
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
      duration: duration,
    });
  }
  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  scrollIfNeeded(element) {
    if (!this.isInViewport(element)) {
      this.scrollToElement.call(this, element);
    }
  }
}

customElements.define("accordion-new-web", CustomAccordion);
